import React from 'react'
import { SvgIconProps } from './Home'

const ErrorTriangle = ({ fill, width, height }: SvgIconProps) => (
  <svg
    width={width ?? '32'}
    height={height ?? '27'}
    viewBox="0 0 32 27"
    fill={fill ?? '#DD5151'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.3824 19.7332L20.9874 3.06961C19.8039 1.37819 18.2367 0 15.9978 0C13.7588 0 12.2235 1.37819 11.0401 3.06961L0.581089 19.8271C-0.21853 21.4246 -0.21853 23.2413 0.741013 24.7761C1.57262 26.123 3.0759 27 4.67514 27H27.2884C28.9196 27 30.3909 26.1543 31.2225 24.7761C32.214 23.2726 32.246 21.2993 31.3824 19.7332ZM15.9978 21.6125C15.0382 21.6125 14.2706 20.8608 14.2706 19.9524C14.2706 19.0441 15.0382 18.261 15.9978 18.261C16.9573 18.261 17.6929 19.0128 17.6929 19.9524C17.6929 20.8921 16.9573 21.6125 15.9978 21.6125ZM17.7249 10.4304L17.1492 15.4733C17.0852 16.0684 16.6694 16.6009 16.0297 16.6009C15.39 16.6009 14.9423 16.0998 14.8783 15.4733L14.3026 10.4304C14.2066 9.58469 15.1342 8.7703 16.0297 8.7703C16.8933 8.73898 17.8209 9.55336 17.7249 10.4304Z"
      fill={fill ?? '#DD5151'}
    />
  </svg>
)

export default ErrorTriangle
